export default __webpack_public_path__ + "static/media/logo.3e078022.jpg";